<template>
  <div>
    <div v-if="!condicion" class="watermark">
      <center>
        <div class="loader-spin"></div>
        <p v-if="!sinTexto" style="font-size:1.5rem; margin-top: 5px; color: #787878;">Cargando datos...</p>
      </center>
    </div>
  </div>
</template>
  
<script>
  export default {
    props: {
      condicion: {
        type: Boolean,
        default: false
      },
      sinTexto: {
        type: Boolean,
        default: false
      }
    },
    components: {},
    data() {
      return {
      };
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    },
  };
</script>

<style scoped>
/* Animación de espera para carga de datos */
/* Clase para aplicar la animación */
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Centra el texto */
  font-size: 2rem;
  
  pointer-events: none; /* Permite interactuar con las celdas debajo */
  white-space: nowrap; /* Evita que el texto se rompa en varias líneas */
}

/* Definimos la animación */
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* Estilo del círculo de animación */
.loader-spin{
  width: 50px;
  height: 50px;
  border: 6px solid #ddd;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>